<template>
  <div class="comment-wrap">
    <!-- USER AVATAR -->
    <figure class="user-avatar medium">
      <img :src="'/images/avatars/' + comment.user.avatar" alt="" />
    </figure>
    <!-- /USER AVATAR -->
    <div class="comment">
      <p class="text-header">
        {{ comment.user.name }}
      </p>

      <p
        @click.prevent="showCommentDeleteModal()"
        v-if="comment.read_at != null"
        :title="'Read: ' + readAt"
        class="report tooltip"
      >
        {{ comment.created_at | fromNowAgo }}
      </p>
      <p @click.prevent="showCommentDeleteModal()" v-else class="report">
        {{ comment.created_at | fromNowAgo }}
      </p>

      <p
        v-if="!comment.files.length && !comment.body"
        class="message"
        style="color: #902f2f;"
      >
        Request failed
      </p>
      <p class="message">{{ comment.body }}</p>

      <p v-if="comment.files.length > 0" class="text-header">Attached files:</p>
      <div
        v-if="comment.files.length > 0"
        v-for="file in comment.files"
        class="file-name"
      >
        <a :href="'/files/' + order.hashId + '/' + file.name">
          <i class="fa fa-arrow-circle-o-down" aria-hidden="true"></i>
        </a>
        <a :href="'/files/' + order.hashId + '/' + file.name">{{
          file.name
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["comment", "order"],
  data() {
    return {};
  },

  created() {
    this.loading = false;
  },

  computed: {
    readAt: function() {
      return this.$options.filters.fromNowAgo(this.comment.read_at);
    },
  },

  methods: {
    showCommentDeleteModal() {
      if (this.$user.can("commentDelete", "commentPolicy")) {
        this.$modal.show("commentDeleteModal", { comment: this.comment });
      }
    },
  },
};
</script>
